module.exports = function(ngModule) {
  ngModule.config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
    $stateProvider.state('auth', {
      url: "/auth",
      template: require('./auth.html'),
      controller: require('./controller.js'),
      controllerAs: 'vm'
    });
  }])
}